import unescapedText from 'I18n/utils/unescapedText';
export const communicationSummaryActionTextParser = action => {
  return unescapedText('copilotToolkit.streamingMessage.communicationSummary', {
    email: action.email
  });
};